import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'

import { WorkflowEditor } from '@/components/settings/workflows/workflow-editor'
import { useCurrentOrganization } from '@/stores/organization.store'

const editorTabSchema = z.object({
  tab: z.enum(['editor', 'runs', 'settings']).optional(),
})

export const Route = createFileRoute('/_app/settings_/workflows/new')({
  validateSearch: editorTabSchema,
  component: NewWorkflowPage,
})

function NewWorkflowPage() {
  const navigate = useNavigate()
  const { tab } = Route.useSearch()
  const { currentOrganization } = useCurrentOrganization()

  if (!currentOrganization) {
    return null
  }

  return (
    <WorkflowEditor
      organizationId={currentOrganization.id}
      definition={null}
      activeTab={tab ?? 'editor'}
      onTabChange={(next) => navigate({ to: '.', search: { tab: next } })}
    />
  )
}
